import { render, staticRenderFns } from "./GaEventDetailsModal.vue?vue&type=template&id=c009a3fa&scoped=true&"
import script from "./GaEventDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./GaEventDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./GaEventDetailsModal.vue?vue&type=style&index=0&id=c009a3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c009a3fa",
  null
  
)

export default component.exports